import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const getInitialLanguage = () => {
  try {
    const prefs = JSON.parse(localStorage.getItem('user_prefs') || '{}');
    if (prefs.language) return prefs.language;
  } catch {
    return 'pt-BR';
  }
  return 'pt-BR';
};

const resources = {
  'pt-BR': {
    translation: {
      appTitle: 'Área do trabalhador',
      login: 'Entrar',
      logout: 'Sair',
      agreements: 'Acordos',
      punchcard: 'Ponto',
      pleas: 'Pedidos',
      profile: 'Perfil',
      privacy: 'Privacidade',
      notifications: 'Notificações',
      dataExport: 'Exportar Dados',
      accountDeletion: 'Excluir Conta',
      noAgreements: 'Nenhum acordo definido',
      selectAgreement: 'Selecione um acordo',
      activeAgreement: 'Acordo ativo',
      history: 'Histórico',
      settings: 'Configurações',
      terms: 'Termos de Serviço',
      consent: 'Consentimento',
      darkMode: 'Modo escuro',
      lightMode: 'Modo claro',
      account: 'Minha conta',
    },
  },
  en: {
    translation: {
      // Add English translations here if needed
    },
  },
  es: {
    translation: {
      // Add Spanish translations here if needed
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
});

// Listen for language changes in user_prefs
// Note: Removed storage event listener as it only fires for cross-tab changes
// Language changes are applied immediately in PrefsPage, so this listener is not needed
// if (typeof window !== 'undefined') {
//   window.addEventListener('storage', () => {
//     try {
//       const prefs = JSON.parse(localStorage.getItem('user_prefs') || '{}');
//       if (prefs.language && i18n.language !== prefs.language) {
//         i18n.changeLanguage(prefs.language);
//       }
//     } catch {}
//   });
// }

export default i18n; 